import { currentRoles, choiceRole } from "@/api/module/user";
import { routerMap, asyncRouteMap, resetRouter } from "@/router";
import { setRole } from "@/utils/auth";

/**
 * 将权限数组转换成对象
 * @param permissions 权限列表
 */
function rolePermissionToMap(permissions) {
  const obj = {};
  permissions.forEach(permission => {
    if (permission.permissons) {
      permission.permissons.forEach(per => {
        obj[per.key] = per;
      });
    }
  });
  return obj;
}

function hasPermission(rolePermissions, routePermission) {
  return routePermission in rolePermissions;
}

const store = {
  state: {
    role: null,
    roles: [],
    permission: [],
    routers: [],
    addRouters: []
  },
  getters: {
    routers(state) {
      return state.routers;
    }
  },
  // methods 同步 $store.commit('SET_NAME')
  mutations: {
    SET_ROLE(state, role) {
      state.role = role;
      setRole(role);
    },
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_PERMISSION(state, permission) {
      state.permission = permission;
    },
    CLEAR_ROLE(state) {
      state.role = null;
      state.roles = [];
      state.permission = [];
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = routerMap.concat(routers);
    }
  },
  // methods 异步 $store.dispatch('SET_NAME')
  actions: {
    async changeRole({ commit, state, dispatch }, roleId) {
      await choiceRole(roleId);
      const curRole = state.roles.find(r => {
        return r.id === roleId;
      });
      commit("SET_ROLE", curRole);
      commit("SET_PERMISSION", rolePermissionToMap(curRole.permissons));
      await dispatch("GenerateRoutes");
      await resetRouter(state.routers);
    },
    GetRoleInfo({ commit }, curRoleNeed = false) {
      return new Promise((resolve, reject) => {
        currentRoles()
          .then(role => {
            if (curRoleNeed === true && !role.roleId) {
              reject(new Error("角色错误"));
              return;
            }

            const curRole = role.roles.find(r => {
              return r.id === role.roleId;
            });

            commit("SET_ROLE", curRole);
            commit("SET_ROLES", role.roles);
            commit("SET_PERMISSION", rolePermissionToMap(curRole.permissons));
            // commit('SET_PERMISSION', permissionMap[curRole.name])
            resolve(role.roles);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    choiceRole({ commit }, roleId) {
      return choiceRole(roleId);
    },
    GenerateRoutes({ commit, state }) {
      return new Promise(resolve => {
        let accessedRouters;

        function routeAllow(routes) {
          const res = [];

          if (routes && routes.length > 0) {
            for (let route of routes) {
              let tmp = { ...route };
              if (route && route.meta && route.meta.permission) {
                if (hasPermission(state.permission, route.meta.permission)) {
                  if (route.children) {
                    tmp.children = routeAllow(route.children);
                  }
                  res.push(tmp);
                }
              } else {
                if (route.children) {
                  tmp.children = routeAllow(route.children);
                }
                res.push(tmp);
              }
            }
          }
          return res;
        }

        accessedRouters = routeAllow(asyncRouteMap);

        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    }
  }
};

export default store;
